import React from 'react'
import PropTypes from 'prop-types'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import withStyles from '@cred/react-theme'

const CtaButton = compProps => {
  const {
      href,
      primary,
      transparent,
      blank,
      fullWidth,
      className,
      small,
      disabled,
      onClick,
      rel,
      navigate,
      analytics,
      match,
      location,
      history,
      staticContext,
      analyticsContexts,
      analyticsOptions,
      overwriteContexts,
      styles = defaultStyles,
      ...props
    } = compProps,
    cls = [styles.cta],
    onClickHandler = proxy => {
      const {onClick, disabled} = compProps

      if (onClick) {
        const additionalEventData = {disabled}

        onClick(proxy, additionalEventData)
      }
    }

  props.target = blank ? '_blank' : '_self'

  if (className) {
    cls.push(className)
  }

  if (primary) {
    cls.push(styles.primary)
  } else {
    cls.push(styles.secondary)
  }

  if (transparent) {
    cls.push(styles.transparent)
  }

  if (fullWidth) {
    cls.push(styles.fullWidth)
  }

  if (small) {
    cls.push(styles.small)
  }

  if (disabled) {
    cls.push(styles.disabled)
  }

  return href ?
    <a
      href={href}
      onClick={onClickHandler}
      className={cls.join(' ')}
      rel={rel}
      {...props}
    />
   :
    <button
      onClick={onClickHandler}
      className={cls.join(' ')}
      {...props}
    />
}

CtaButton.propTypes = {
  primary: PropTypes.bool,
  transparent: PropTypes.bool,
  fullWidth: PropTypes.bool,
  blank: PropTypes.bool,
  small: PropTypes.bool,
  rel: PropTypes.string,
  disabled: PropTypes.bool,
  history: PropTypes.object,
  styles: PropTypes.object
}

CtaButton.defaultProps = {
  primary: true,
  transparent: false,
  fullWidth: false,
  blank: false,
  small: false,
  rel: '',
  disabled: false,
  history: {}
}

CtaButton.displayName = 'CtaButton'

export {CtaButton as CtaButtonNoHoc}

export default withStyles(defaultStyles, {fox1})(CtaButton)
